import { once } from 'ramda';
import { sendDwhButton } from 'reactApp/modules/dwh/dwh.helpers';
import { renderFakedoorNeuroOrganizerDialog } from 'reactApp/ui/FakedoorNeuroOrganizePromo/Popup/FakedoorNeuroOrganizerDialog';
import { sendXray } from 'reactApp/utils/ga';

const handleClickFactory = (type: 'search' | 'sort' | 'multisort') => () => {
    sendXray([`${type}bttn`, 'ai_organize', 'click']);
    sendDwhButton({ action: 'click', name: `mnz_ai_org_${type}_bttn` });

    renderFakedoorNeuroOrganizerDialog({ isByClick: true });
};

const handleShowFactory = (type: 'search' | 'sort' | 'multisort') =>
    once(() => {
        sendXray([`${type}bttn`, 'ai_organize', 'show']);
        sendDwhButton({ name: `mnz_ai_org_${type}_bttn` });
    });

export const handleShowAiOrganizeFakedoorSearchToolbarItem = handleShowFactory('search');
export const handleClickAiOrganizeFakedoorSearchToolbarItem = handleClickFactory('search');

export const handleShowAiOrganizeFakedoorSortToolbarItem = handleShowFactory('sort');
export const handleClickAiOrganizeFakedoorSortToolbarItem = handleClickFactory('sort');

export const handleShowAiOrganizeFakedoorMultiSortToolbarItem = handleShowFactory('multisort');
export const handleClickAiOrganizeFakedoorMultiSortToolbarItem = handleClickFactory('multisort');
